// TinyMCE adds in "Bookmark" elements which it uses for substituting
// things in like images and tables. See PR #31077 for context
function isTinyMCEBookmarkElement(htmlString) {
  return htmlString === '<span id="mce_marker" data-mce-type="bookmark">&#xFEFF;&#x200B;</span>';
}

export { isTinyMCEBookmarkElement };
